export enum ShipmentStatus {
  BillingInfo = 0,
  Manifest = 1,
  PickupScan = 2,
  Voided = 3,
  LabelPrinted = 4,
  InTransit = 5,
  Delivered = 6,
  Exception = 7,
  ReprintRequested = 8,
  TNF = 9,
  BIRNew = 10,
  VoidButInTransit = 11,
  VoidButDelivered = 12,
  VoidButException = 13,
  Reinstated = 14,
}
